<div class="dialog" [class.blocked]="isBlocked">
    <!-- Blocking overlay when external changes were detected -->
    <div *ngIf="isBlocked" class="blocking-overlay">
        <div class="blocking-message">
            <icc-icon name="warning" class="warning-icon"></icc-icon>
            <p>{{ 'COMPLAINT|Reklamacja została zmodyfikowana przez innego użytkownika. Dane w tym oknie są nieaktualne i zostały zablokowane do edycji. Zamknij okno i otwórz ponownie, aby zobaczyć aktualne dane.' | translate }}</p>
            <div class="blocking-actions">
                <button iccButton appearance="primary" (click)="close()">
                    {{ 'INTERFACE|Zamknij' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Edycja pozycji' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-vertical mb-2 w-100">

            <icc-complaint-position-edit
                [(complaint)]="data.complaint"
                [(complaintPosition)]="data.position"
                [(complaintPositionAttachments)]="data.attachments"
                [showRemoveButton]="false"
            ></icc-complaint-position-edit>

        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <button
                iccButton
                (click)="save()"
                appearance="primary"
                [disabled]="data.position.invalidSerialNumber && data.position.complaintDocumentType === 'serialNumber'"
            >
                {{ 'INTERFACE|Zapisz' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>